<!--
 * @Description: 跟进记录新增编辑
 * @Author: cxh
 * @Date: 2022-05-24 15:19:34
 * @LastEditTime: 2022-09-28 14:36:09
 * @LastEditors: cxh
-->
<template>
  <dc-layout-main>
    <dc-layout-content>
      <baseMessage :disabled="false" :data="form" :permissionPage="permissionBasic"/>
    </dc-layout-content>
  </dc-layout-main>
</template>
<script lang="ts" setup>
import { ref, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import baseMessage from '../components/baseMessage.vue'
import { visitorProgramDetail } from '@/api/yuntuSales/followUpManage'
import type { LbuFollowUpRecordEdit } from '@/typings/api/followUpManage'
const route = useRoute()
const form = ref<LbuFollowUpRecordEdit>({
  visitPlanList: []
})
const permissionBasic = {
  save: 'lbu_visitor_complete_btn'
}
// 获取访客计划详情
const getvisitorProgramDetail = () => {
  visitorProgramDetail(route.query.planId as string).then((res) => {
    const {
      id,
      mode,
      customerName,
      endTime,
      startTime,
      contactId,
      chanceId,
      chanceName,
      visitRefId,
      purpose,
      fbuAssistPersons
    } = res.data
    form.value = {
      ...form.value,
      planId: id,
      mode,
      endTime,
      startTime,
      contactId,
      chanceId,
      chanceName,
      fbuPurpose: purpose,
      fbuAssistPersons,
      customerName,
      followRefId: visitRefId,
      lbuVisitPurpose: purpose
    }
  })
}
onMounted(() => {
  if (route.query.planId) {
    getvisitorProgramDetail()
  }
})
</script>
<script lang="ts">
export default {
  name: 'DcCosLbuFollowUpRecordVisitingPlan'
}
</script>
